import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaBacktop from './VaBacktop.vue'

export const VaBacktop = withConfigTransport(_VaBacktop)
